<template lang="pug">
.modern-sidebar(:class='{ collapsed: isCollapsed }')
  //- Logo Section
  .sidebar-logo
    img.logo-full(
      v-if='!isCollapsed',
      src='@/assets/logo-escality.svg',
      alt='ESCALITY.ai'
    )
    img.logo-icon(
      v-else,
      src='@/assets/isotipo-escality.svg',
      alt='ESCALITY',
      @click='toggleSidebar'
    )

  //- Toggle Button
  button.sidebar-toggle(@click='toggleSidebar')
    i.pi(:class='isCollapsed ? "pi-angle-right" : "pi-angle-left"')

  //- Navigation Menu
  nav.sidebar-nav
    ul.nav-list

      //- ══════ OPERACIONES ══════
      li.section-header(v-if='!isCollapsed')
        span Operaciones

      //- Ventas
      li.nav-item.has-submenu
        a.nav-link(
          :class='{ active: isMenuActive("ventas"), expanded: expandedMenus.ventas }',
          @click='toggleSubmenu("ventas")'
        )
          i.pi.pi-shopping-cart.nav-icon
          span.nav-text(v-if='!isCollapsed') Ventas
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.ventas && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Ventas' }") Facturas
            li(v-can='\'PRESUPUESTOS\'')
              router-link.submenu-link(:to="{ name: 'Presupuestos' }") Presupuestos
            li
              router-link.submenu-link(:to="{ name: 'Notas de pedido' }") Notas de Pedido
            li
              router-link.submenu-link(:to="{ name: 'Remitos de venta' }") Remitos

      //- Compras
      li.nav-item.has-submenu(v-can='\'compras\'')
        a.nav-link(
          :class='{ active: isMenuActive("compras"), expanded: expandedMenus.compras }',
          @click='toggleSubmenu("compras")'
        )
          i.pi.pi-shopping-bag.nav-icon
          span.nav-text(v-if='!isCollapsed') Compras
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.compras && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Compras' }") Facturas
            li
              router-link.submenu-link(:to="{ name: 'Remitos de compra' }") Remitos

      //- Pedidos Online
      //- Vive en OPERACIONES y no en una sección propia: es un pedido, igual que
      //- los de Ventas. Estaba en una sección CANALES de dos ítems; al quedar uno
      //- solo, el título flotaba sobre un único ítem que además es condicional al
      //- permiso `ecommerce`, así que la sección se disolvió.
      li.nav-item(v-can='\'ecommerce\'')
        router-link.nav-link(:to="{ name: 'Pedidos Ecommerce' }", :class='{ active: isMenuActive("ecommerce") }')
          i.pi.pi-globe.nav-icon
          span.nav-text(v-if='!isCollapsed') Pedidos Online

      //- ══════ CONTACTOS ══════
      li.section-header(v-if='!isCollapsed')
        span Contactos

      //- Clientes
      li.nav-item.has-submenu(v-can='\'CLIENTES\'')
        a.nav-link(
          :class='{ active: isMenuActive("clientes"), expanded: expandedMenus.clientes }',
          @click='toggleSubmenu("clientes")'
        )
          i.pi.pi-users.nav-icon
          span.nav-text(v-if='!isCollapsed') Clientes
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.clientes && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Clientes' }") Clientes
            li
              router-link.submenu-link(:to="{ name: 'Vendedores' }") Vendedores

      //- Proveedores
      li.nav-item.has-submenu(v-can='\'PROVEEDORES\'')
        a.nav-link(
          :class='{ active: isMenuActive("proveedores"), expanded: expandedMenus.proveedores }',
          @click='toggleSubmenu("proveedores")'
        )
          i.pi.pi-building.nav-icon
          span.nav-text(v-if='!isCollapsed') Proveedores
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.proveedores && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Proveedores' }") Proveedores
            li
              router-link.submenu-link(:to="{ name: 'Transportes' }") Transportes

      //- ══════ FINANZAS ══════
      li.section-header(v-if='!isCollapsed')
        span Finanzas

      //- Cobranzas
      li.nav-item.has-submenu(v-can='\'CLIENTES_CTA_CORRIENTE\'')
        a.nav-link(
          :class='{ active: isMenuActive("cobranzas"), expanded: expandedMenus.cobranzas }',
          @click='toggleSubmenu("cobranzas")'
        )
          i.pi.pi-dollar.nav-icon
          span.nav-text(v-if='!isCollapsed') Cobranzas
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.cobranzas && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Cobranzas' }") Recibos
            li
              router-link.submenu-link(:to="{ name: 'Cuenta corriente de clientes' }") CC Clientes

      //- Pagos
      li.nav-item.has-submenu(v-can='\'PROVEEDORES_CTA_CORRIENTE\'')
        a.nav-link(
          :class='{ active: isMenuActive("pagos"), expanded: expandedMenus.pagos }',
          @click='toggleSubmenu("pagos")'
        )
          i.pi.pi-credit-card.nav-icon
          span.nav-text(v-if='!isCollapsed') Pagos
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.pagos && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Pago a proveedores' }") Órdenes de Pago
            li
              router-link.submenu-link(:to="{ name: 'Cuenta corriente de proveedores' }") CC Proveedores

      //- Tesorería
      li.nav-item.has-submenu(v-can='\'cajas\'')
        a.nav-link(
          :class='{ active: isMenuActive("cajas"), expanded: expandedMenus.cajas }',
          @click='toggleSubmenu("cajas")'
        )
          i.pi.pi-wallet.nav-icon
          span.nav-text(v-if='!isCollapsed') Tesorería
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.cajas && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Cajas' }") Cajas
            li(v-can='\'CHEQUES\'')
              router-link.submenu-link(:to="{ name: 'Cheques de Terceros' }") Cheques de Terceros
            li(v-can='\'CHEQUES\'')
              router-link.submenu-link(:to="{ name: 'Cheques Propios' }") Cheques Propios
            li
              router-link.submenu-link(:to="{ name: 'Cupones en cartera' }") Cupones en Cartera
            li(v-can='\'CAJAS_CATEGORIAS\'')
              router-link.submenu-link(:to="{ name: 'Categorias Cajas' }") Categorías Cajas

      //- ══════ PRODUCTOS ══════
      li.section-header(v-if='!isCollapsed')
        span Productos

      //- Productos
      li.nav-item.has-submenu(v-can='\'inventario\'')
        a.nav-link(
          :class='{ active: isMenuActive("inventario"), expanded: expandedMenus.productos }',
          @click='toggleSubmenu("productos")'
        )
          i.pi.pi-box.nav-icon
          span.nav-text(v-if='!isCollapsed') Productos
          i.pi.pi-angle-down.submenu-arrow(v-if='!isCollapsed')
        transition(name='submenu')
          ul.submenu(v-if='expandedMenus.productos && !isCollapsed')
            li
              router-link.submenu-link(:to="{ name: 'Inventario' }") Productos
            li
              router-link.submenu-link(:to="{ name: 'Categorias de inventario' }") Categorías
            li
              router-link.submenu-link(:to="{ name: 'Marcas de productos' }") Marcas
            li.submenu-header Stock
            li(v-can='\'STOCK_MOVIMIENTO\'')
              router-link.submenu-link(:to="{ name: 'Existencias en stock' }") Existencias
            li(v-can='\'STOCK_MOVIMIENTO\'')
              router-link.submenu-link(:to="{ name: 'Movimientos de stock' }") Movimientos
            li
              router-link.submenu-link(:to="{ name: 'Depositos' }") Depósitos
            li.submenu-header Precios
            li
              router-link.submenu-link(:to="{ name: 'Consulta de Precio' }") Consulta
            li(v-can='\'PRECIOS_ACTUALIZADOR\'')
              router-link.submenu-link(:to="{ name: 'Actualizacion de precios' }") Actualización
            li
              router-link.submenu-link(:to="{ name: 'Listas de precios' }") Listas de Precios
            li.submenu-header Herramientas
            li
              router-link.submenu-link(:to="{ name: 'Catalogos' }") Catálogos
            li(v-can='\'inventario_cargar_masivo\'')
              router-link.submenu-link(:to="{ name: 'Importexcel' }") Importar CSV

      //- ══════ SISTEMA ══════
      li.section-header(v-if='!isCollapsed')
        span Sistema

      //- Reportes IA
      li.nav-item(v-can='\'reportes\'')
        router-link.nav-link(:to="{ name: 'AiReports' }", :class='{ active: isMenuActive("reportes") }')
          i.pi.pi-sparkles.nav-icon
          span.nav-text(v-if='!isCollapsed') Reportes
          span.beta-badge-nav(v-if='!isCollapsed') IA
</template>

<script>
import { useMeStore } from '@/stores/me';

export default {
  name: 'ModernSidebar',
  data() {
    return {
      isCollapsed: false,
      expandedMenus: {
        ventas: false,
        compras: false,
        clientes: false,
        proveedores: false,
        cobranzas: false,
        pagos: false,
        cajas: false,
        productos: false,
      },
      salesclerkModule: 0,
    };
  },
  computed: {
    authUser() {
      const meStore = useMeStore();
      return meStore.getUser;
    },
  },
  watch: {
    authUser: {
      handler(newUser) {
        if (
          newUser &&
          newUser.branchoffices &&
          newUser.branchoffices[0] &&
          newUser.branchoffices[0].options
        ) {
          this.salesclerkModule =
            newUser.branchoffices[0].options.salesclerk_module === null
              ? false
              : true;
        }
      },
      immediate: true,
    },
    $route() {
      // Auto-expand active menu
      this.autoExpandActiveMenu();
    },
  },
  mounted() {
    // Load collapsed state from localStorage
    const savedState = localStorage.getItem('sidebarCollapsed');
    if (savedState !== null) {
      this.isCollapsed = savedState === 'true';
    }

    // Auto-expand active menu on mount
    this.autoExpandActiveMenu();

    // Emit event to notify parent about sidebar state
    this.$emit('sidebar-toggle', this.isCollapsed);
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
      localStorage.setItem('sidebarCollapsed', this.isCollapsed);
      this.$emit('sidebar-toggle', this.isCollapsed);

      // Close all submenus when collapsing
      if (this.isCollapsed) {
        Object.keys(this.expandedMenus).forEach(key => {
          this.expandedMenus[key] = false;
        });
      }
    },

    handleLogoError(event) {
      // Fallback to original logo if custom fails
      console.log('Logo load failed, using fallback');
      event.target.src = '/src/assets/logo-escality.svg';
    },

    toggleSubmenu(menu) {
      if (this.isCollapsed) {
        this.isCollapsed = false;
        this.$emit('sidebar-toggle', false);
        localStorage.setItem('sidebarCollapsed', false);
      }

      // Close other submenus
      Object.keys(this.expandedMenus).forEach(key => {
        if (key !== menu) {
          this.expandedMenus[key] = false;
        }
      });

      // Toggle current submenu
      this.expandedMenus[menu] = !this.expandedMenus[menu];
    },

    isMenuActive(menu) {
      const path = this.$route.path;
      const routeMenu = this.$route.meta?.menu;
      if (routeMenu === menu) return true;

      // Secciones compuestas por múltiples prefijos de ruta
      if (menu === 'clientes') return path.startsWith('/clientes') || path.startsWith('/vendedores');
      if (menu === 'proveedores') return path.startsWith('/proveedores') || path.startsWith('/transportes');
      if (menu === 'cobranzas') return path.startsWith('/cobranzas') || path.startsWith('/cc-clientes');
      if (menu === 'pagos') return path.startsWith('/cc-proveedores') || (path.startsWith('/compras/pagos'));
      if (menu === 'inventario') return path.startsWith('/inventario') || path.startsWith('/ecommerce/catalogos');

      return path.startsWith(`/${menu}`);
    },

    autoExpandActiveMenu() {
      const path = this.$route.path;
      const routeMenu = this.$route.meta?.menu;

      // Primero verificar meta.menu para rutas de primer nivel
      if (routeMenu) {
        if (Object.prototype.hasOwnProperty.call(this.expandedMenus, routeMenu)) {
          this.expandedMenus[routeMenu] = true;
          return;
        }
      }

      if (path.startsWith('/ventas')) {
        this.expandedMenus.ventas = true;
      } else if (path.startsWith('/compras')) {
        this.expandedMenus.compras = true;
      } else if (path.startsWith('/clientes') || path.startsWith('/vendedores')) {
        this.expandedMenus.clientes = true;
      } else if (path.startsWith('/proveedores') || path.startsWith('/transportes')) {
        this.expandedMenus.proveedores = true;
      } else if (path.startsWith('/cobranzas') || path.startsWith('/cc-clientes')) {
        this.expandedMenus.cobranzas = true;
      } else if (path.startsWith('/cc-proveedores')) {
        this.expandedMenus.pagos = true;
      } else if (path.startsWith('/cajas')) {
        this.expandedMenus.cajas = true;
      } else if (path.startsWith('/inventario') || path.startsWith('/ecommerce/catalogos')) {
        this.expandedMenus.productos = true;
      }
    },

    goToProfile() {
      this.$router.push({ name: 'Mi Perfil' });
    },

    goToSettings() {
      this.$router.push({ name: 'Usuarios del sistema' });
    },

    async logout() {
      await useMeStore().logout();
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style scoped>
/* ESCALITY ModernSidebar Design System 2025 - Usando Variables Centralizadas */
.modern-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: var(--escality-sidebar-width);
  background: linear-gradient(180deg, var(--escality-surface) 0%, var(--escality-gray-50) 100%);
  border-right: 1px solid var(--escality-gray-200);
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1040;
  box-shadow: var(--escality-shadow-sm);
}

.modern-sidebar.collapsed {
  width: var(--escality-sidebar-width-collapsed);
}

/* Logo Section */
.sidebar-logo {
  padding: 24px 20px;
  border-bottom: 1px solid var(--escality-gray-200);
  background: white;
  min-height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-full {
  width: 210px;
  height: auto;
  max-height: 45px;
  object-fit: contain;
}

.logo-icon {
  width: 35px;
  height: 35px;
  cursor: pointer;
  transition: transform 0.2s;
}

.logo-icon:hover {
  transform: scale(1.1);
}

/* Toggle Button */
.sidebar-toggle {
  position: absolute;
  top: 25px;
  right: -12px;
  width: 24px;
  height: 24px;
  border-radius: var(--escality-radius-full);
  background: white;
  border: 1px solid var(--escality-gray-300);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sidebar-toggle:hover {
  background: var(--escality-primary);
  color: white;
  border-color: var(--escality-primary);
  transform: scale(1.1);
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px 0;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Section Headers */
.section-header {
  padding: 16px 20px 6px 20px;
  font-size: 10px;
  font-weight: var(--escality-font-weight-bold);
  color: var(--escality-gray-400);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  font-family: var(--escality-font-body);
  list-style: none;
}

.section-header:first-child {
  padding-top: 4px;
}

.nav-item {
  position: relative;
  margin-bottom: 2px;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: var(--escality-gray-700);
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
  font-size: var(--escality-text-base);
  font-weight: var(--escality-font-weight-medium);
  border-radius: var(--escality-radius-md);
  margin: 2px 10px;
  font-family: var(--escality-font-body);
}

/* Ajuste para sidebar colapsado */
.collapsed .nav-link {
  padding: 12px 0;
  justify-content: center;
  margin: 2px 8px;
}

.nav-link:hover {
  background: rgba(37, 99, 235, 0.08);
  color: var(--escality-primary);
}

.nav-link.active {
  background: linear-gradient(135deg, var(--escality-primary-50) 0%, var(--escality-primary-100) 100%);
  color: var(--escality-primary);
  font-weight: var(--escality-font-weight-semibold);
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.1);
}

.nav-icon {
  font-size: 20px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Main menu items with submenu */
.nav-item.has-submenu > .nav-link {
  background: var(--escality-gray-50);
  border: 1px solid var(--escality-gray-200);
  font-weight: var(--escality-font-weight-semibold);
}

.nav-item.has-submenu > .nav-link:hover {
  background: white;
  border-color: var(--escality-primary);
}

.nav-item.has-submenu > .nav-link.expanded {
  background: white;
  border-color: var(--escality-primary);
  box-shadow: var(--escality-shadow-md);
}

/* Ajuste para items con submenu cuando está colapsado */
.collapsed .nav-item.has-submenu > .nav-link {
  background: transparent;
  border: none;
}

.nav-text {
  margin-left: 12px;
  white-space: nowrap;
}

.submenu-arrow {
  margin-left: auto;
  font-size: var(--escality-text-xs);
  transition: transform 0.2s;
}

.nav-link.expanded .submenu-arrow {
  transform: rotate(180deg);
}

/* Submenu */
.submenu {
  list-style: none;
  padding: 8px 0;
  margin: 0 10px;
  background: var(--escality-gray-50);
  border-radius: var(--escality-radius-md);
  border: 1px solid var(--escality-gray-200);
  overflow: hidden;
  margin-top: 4px;
}

.submenu-link {
  display: block;
  padding: 8px 20px 8px 48px;
  color: var(--escality-gray-600);
  text-decoration: none;
  font-size: var(--escality-text-sm);
  transition: all 0.2s;
  position: relative;
  margin: 2px 8px;
  border-radius: var(--escality-radius-sm);
  font-family: var(--escality-font-body);
}

.submenu-link:hover {
  color: var(--escality-primary);
  background: rgba(37, 99, 235, 0.05);
}

.submenu-link.router-link-active {
  color: white;
  font-weight: var(--escality-font-weight-medium);
  background: var(--escality-gradient-primary);
}

.submenu-link.router-link-active::before {
  color: white;
}

.submenu-link::before {
  content: '•';
  position: absolute;
  left: 32px;
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--escality-text-md);
  color: var(--escality-gray-400);
  line-height: 1;
}

.submenu-header {
  padding: 10px 20px 6px 48px;
  font-size: 10px;
  font-weight: var(--escality-font-weight-bold);
  color: var(--escality-gray-400);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 12px;
  margin-bottom: 4px;
  border-top: 1px solid var(--escality-gray-200);
  background: white;
  font-family: var(--escality-font-body);
}

/* Submenu Animation */
.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
}

.submenu-enter,
.submenu-leave-to {
  max-height: 0;
  opacity: 0;
}

/* Scrollbar Styling */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: var(--escality-gray-300);
  border-radius: var(--escality-radius-full);
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: var(--escality-gray-400);
}

/* Responsive */
@media (max-width: 768px) {
  .modern-sidebar {
    transform: translateX(-100%);
  }

  .modern-sidebar.mobile-open {
    transform: translateX(0);
  }

  .modern-sidebar.collapsed {
    transform: translateX(-100%);
  }
}

.beta-badge-nav {
  font-size: 0.55rem;
  font-weight: var(--escality-font-weight-bold);
  background: linear-gradient(135deg, var(--escality-primary), var(--escality-secondary));
  color: white;
  padding: 1px 6px;
  border-radius: var(--escality-radius-md);
  letter-spacing: 0.5px;
  margin-left: auto;
}
</style>